/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Login_Offline_Activation_Failed_With_ErrorInputs */



/**
* | output |
* | --- |
* | "Activation Failed. {message}" |
*
* @param {Login_Offline_Activation_Failed_With_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_offline_activation_failed_with_error = /** @type {((inputs: Login_Offline_Activation_Failed_With_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Offline_Activation_Failed_With_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Activation echouee. ${i?.message}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Aktivierung fehlgeschlagen. ${i?.message}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Attivazione fallita. ${i?.message}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Активация не удалась. ${i?.message}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Activación fallida. ${i?.message}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`激活失败。${i?.message}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`アクティベーションに失敗しました。${i?.message}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`सक्रियण विफल। ${i?.message}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`A ativação falhou. ${i?.message}`)
	return /** @type {LocalizedString} */ (`Activation Failed. ${i?.message}`)
});